import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { authAPI } from '../api/client';
import { useAuth } from '../context/AuthContext';
import { apiError, appUrl, goTo } from '../lib/host';
import './Layout.css';

const when = (iso) => new Date(`${iso}Z`).toLocaleString();

/** Where this account is signed in, with remote sign-out. */
export default function DevicesCard() {
  const { logout } = useAuth();
  const navigate = useNavigate();
  const [devices, setDevices] = useState([]);
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  const load = useCallback(() => {
    authAPI.sessions().then((res) => setDevices(res.data)).catch((err) => setError(apiError(err)));
  }, []);
  useEffect(load, [load]);

  const run = async (fn) => {
    setBusy(true);
    setError('');
    try {
      await fn();
      load();
    } catch (err) {
      setError(apiError(err));
    } finally {
      setBusy(false);
    }
  };

  const signOutEverywhere = async () => {
    await logout({ everywhere: true });
    if (window.location.hostname.startsWith('app.')) navigate('/login');
    else goTo(appUrl('/login'));
  };

  return (
    <section className="tcx-panel">
      <h3>Devices</h3>
      <p className="tcx-muted" style={{ marginBottom: 12 }}>
        Places where you're signed in. Signing a device out takes effect on its next request.
      </p>
      {error && <div className="admin-error">{error}</div>}
      <div className="tcx-table-wrap">
        <table className="tcx-table">
          <thead><tr><th>Device</th><th>IP</th><th>Signed in</th><th>Last active</th><th /></tr></thead>
          <tbody>
            {devices.map((d) => (
              <tr key={d.id}>
                <td>
                  {d.device}
                  {d.current && <span className="tcx-role tcx-role-member" style={{ marginLeft: 8 }}>This device</span>}
                  {d.remember_me && <span className="tcx-muted" style={{ marginLeft: 8 }}>kept signed in</span>}
                </td>
                <td>{d.ip || '—'}</td>
                <td>{when(d.created_at)}</td>
                <td>{when(d.last_seen_at)}</td>
                <td>
                  {!d.current && (
                    <button className="tcx-btn secondary" disabled={busy} onClick={() => run(() => authAPI.endSession(d.id))}>
                      Sign out
                    </button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="tcx-actions" style={{ marginTop: 14 }}>
        <button className="tcx-btn secondary" disabled={busy || devices.length < 2}
          onClick={() => run(() => authAPI.signOutOthers())}>
          Sign out all other devices
        </button>
        <button className="tcx-btn danger" disabled={busy} onClick={signOutEverywhere}>Sign out everywhere</button>
      </div>
    </section>
  );
}
